const VideoEmbedBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g>
      <g>
        <rect x="1" y="1" width="22" height="22" fill="#ffd400" />
        <path d="M22,2V22H2V2H22m2-2H0V24H24V0Z" fill="#333" />
      </g>
      <rect x="6" y="6" width="12" height="12" fill="#333" />
      <polygon
        points="15.58 11.81 12.79 13.71 10 15.61 10 11.81 10 8 12.79 9.9 15.58 11.81"
        fill="#ffd400"
      />
    </g>
  </svg>
);

export default VideoEmbedBlockIcon;
